import "./tabs.scss";

import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../../common/notification-message/notification";
import { DatePicker } from "antd";
import Loading from "../../../loader/loader";
import DeleteUser from "../../../settings/deleteUser";
import NkTable from "../../nktable";
import RechargeBeneficiaryFilter from "../modals/recharge-beneficiary-filter";
import Select from "react-select";
import {
  getTabRechargeBeneficiaryList,
  deleteMobileRecharge,
} from "../../../../service/profile-ras-service";
import moment from "moment";

const RechargeBeneficiariesTab = ({ userId }) => {
  const [modalShow, setModalShow] = useState(false);
  const [searchBy, setSearchBy] = useState("receiver");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [allUserList, setAllUserList] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [rakTab, setRakTab] = useState([]);
  const [sizeShow, setSizeShow] = useState();
  const [type, setType] = useState([]);
  const [country, setCountry] = useState([]);
  const [beneficiaryid, setBeneficiaryid] = useState("");
  const [buttonloading, setButtonloading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const request = {
    page: 1,
    size: 10,
    beneficiaryName: "",
    receiver: "",
    fromDate: "",
    toDate: "",
    searchType: "",
    searchCountry: "",
    searchStatus: "",
    c3REF: "",
    isFilter: false,
    typeLength: "",
    countryLength: "",
  };
  const [filterForm, setFilterForm] = useState(request);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });

  const columns = [
    {
      dataField: "registrationDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.registrationDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "beneficiary",
      text: "Beneficiary",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "type",
      text: "Type",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "accountNumber",
      text: "Receiver",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },

    {
      dataField: "countryName",
      text: "Country",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "actions",
      text: "Action",
      sort: false,
      formatter: (cell, row) => {
        return (
          <i
            className="fas fa-trash-alt"
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (row && row.id) {
                setBeneficiaryid(row.id);
                setDeleteModal(true);
              }
            }}
          />
        );
      },
    },
    // {
    //   dataField: "PartnerReference",
    //   text: "Ding Transaction Ref Number",
    //   sort: false,
    //   style: { minWidth: "140px", textAlign: "left" },
    // },
  ];

  const [id, setId] = useState();

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getTabRechargebeneficiaryListDD(filterForm, id);
    }
  }, [id]);

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getTabRechargebeneficiaryListDD(filterForm, id);
    }
  }, [filterForm]);

  const getTabRechargebeneficiaryListDD = (request, id) => {
    request["searchType"] =
      request.searchType.length == 0 ? "" : request.searchType;
    request["searchCountry"] =
      request.searchCountry.length == 0 ? "" : request.searchCountry;
    request.size = sizeShow || 10;
    setDataLoading(true);
    getTabRechargeBeneficiaryList(request, id)
      .then((res) => {
        setDataLoading(false);
        setRakTab(res.data.rechargeBeneficiaries || []);
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        console.log(err);
        setRakTab([]); // TODO -NEED TO REMOVE
      });
  };

  const handleFilter = () => {
    let request = {};
    if (searchBy === "receiver") {
      request = {
        ...filterForm,
        receiver: searchByValue,
        beneficiaryName: null,
      };
    } else if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiaryName: searchByValue,
        receiver: null,
      };
    }
    if (filterForm.searchCountry && filterForm.searchCountry.length > 0) {
      let a = "";
      filterForm.searchCountry &&
        filterForm &&
        filterForm.searchCountry.forEach((v, i) => {
          console.log(v);
          a =
            a + v.value + (i + 1 < filterForm.searchCountry.length ? "," : "");
        });
      request.searchCountry = a || "";
    } else {
      request.searchCountry = filterForm.searchCountry || "";
    }

    if (filterForm.searchType && filterForm.searchType.length > 0) {
      let a = "";
      filterForm &&
        filterForm.searchType &&
        filterForm.searchType.forEach((v, i) => {
          console.log(v);
          a = a + v.value + (i + 1 < filterForm.searchType.length ? "," : "");
        });
      request.searchType = a || "";
    } else {
      request.searchType = filterForm.searchType || "";
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.searchFilter = "";
    request.page = 1;
    request.isFilter = true;

    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "receiver") {
    searchByValuePlaceholder = "eg.971507878961";
  } else if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "Amit Pandit";
  }
  //Delete APi
  const onDelete = () => {
    setButtonloading(true);
    deleteMobileRecharge(beneficiaryid)
      .then((res) => {
        setDeleteModal(false);
        setButtonloading(false);
        //message.success("Delete Successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Deleted Successfully"
        );
        getTabRechargebeneficiaryListDD(filterForm, id);
      })
      .catch((err) => {
        setDeleteModal(false);
        setButtonloading(false);
        //openNotificationWithIcon(notificationStrings.error, err);
        // message.error("Something went wrong");
      });
  };

  const resetFilter = () => {
    setSearchBy("receiver");
    request.isFilter = true;
    setType([]);
    setCountry([]);
    setFromDate(null);
    setToDate(null);
    setFilterValues(false);
    setSearchByValue("");
    setRakTab([]);
    setFilterForm(request);
  };

  const clearFilter = () => {
    setFilterForm({
      ...filterForm,
      searchType: "",
      searchCountry: "",
      typeLength: 0,
      countryLength: 0,
      totalLength: 0,
    });
    setType([]);
    setCountry([]);
  };
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  console.log("searchBy", searchBy);

  return (
    <>
      <Row
        style={{ marginLeft: "0px", marginRight: "0px", padding: "12px 0px" }}
      >
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Search by
            </label>
            <Input
              id="exampleFormControlSelect1"
              style={{ height: "28px" }}
              type="select"
              value={searchBy}
              onChange={(e) => {
                setSearchBy(e.target.value);
              }}
            >
              <option value="receiver">Receiver</option>
              <option value="beneficiary">Beneficiary</option>
            </Input>
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label className="form-control-label" htmlFor="example3cols2Input">
              Search for
            </label>
            <Input
              id="example3cols2Input"
              placeholder={searchByValuePlaceholder}
              type="text"
              style={{ height: "27px" }}
              onKeyPress={(e) => e.charCode === 13 && handleFilter(true)}
              onChange={(e) =>
                setSearchByValue(
                  e.target && e.target.value && e.target.value.trim()
                )
              }
              value={searchByValue}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              From
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setFromDate(moment(dateString, dateFormat));
                } else {
                  setFromDate(null);
                }
              }}
              value={fromDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              To
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setToDate(moment(dateString, dateFormat));
                } else {
                  setToDate(null);
                }
              }}
              value={toDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <div
          lg="1"
          className="form-input-padding-tab"
          style={{ marginTop: "2px" }}
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Filter by
            </Label>
            <div>
              <Button
                style={{ width: "100%", height: "26px" }}
                color="primary"
                type="button"
                id="example3cols2Input"
                className="filter-button"
                onClick={() => setShowFilterModal(true)}
              >
                <div>
                  {" "}
                  <i class="fas fa-filter"></i>
                </div>
              </Button>
            </div>
          </FormGroup>

          <span style={{ fontSize: 8 }}>
            {filterForm ? (
              filterForm.totalLength > 0 ? (
                <>
                  {console.log("FILTER ::", filterForm)}
                  <h6 style={{ display: "flex", alignItems: "center" }}>
                    selected({filterForm.totalLength})
                    <i
                      class="fas fa-window-close"
                      style={{ cursor: "pointer", paddingLeft: "5px" }}
                      onClick={() => clearFilter()}
                    />
                  </h6>
                </>
              ) : (
                <></>
              )
            ) : (
              ""
            )}
          </span>
        </div>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                type="button"
                style={{
                  width: "100%",
                  background: "#e91d24",
                  color: "white",
                  height: "26px",
                  border: "1px solid rgb(233, 29, 36)",
                }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => handleFilter(true)}
              >
                <div>
                  <i class="fas fa-search"></i>
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                color="light"
                type="button"
                style={{ width: "100%", height: "26px" }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => resetFilter()}
              >
                <div
                  style={{
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  <i class="fas fa-redo-alt 2px"></i> Reset
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
      </Row>
      {rakTab.length < 0 ? (
        <>
          <Card
            className="mb-4"
            style={{
              display: "flex",
              flex: 1,
              textAlign: "center",
              justifyContent: "center",
              padding: "1.25rem 1.5rem",
            }}
          >
            <CardBody>
              <h3 className="mb-0">No Records Found</h3>
              {/* <h1 className="mb-0">Sorry ! We cannot find it</h1>
              <h3 className="mb-0">
                Enter a different search term or remove any filters and try
                again
              </h3> */}
            </CardBody>
          </Card>
        </>
      ) : (
        <>
          <Row style={{ padding: "1.25rem 0.5rem" }}>
            <div className="col card-parent">
              <Card>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      filename={"All-User-List"}
                      data={rakTab}
                      columns={columns}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                          isFilter: true,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                          page: pageSize,
                          isFilter: true,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      )}
      <RechargeBeneficiaryFilter
        show={showFilterModal}
        onHide={() => {
          setShowFilterModal(false);
        }}
        type={type}
        setType={setType}
        country={country}
        setCountry={setCountry}
        saveButtonClicked={(saveResponse) => {
          console.log(saveResponse);
          setFilterForm({ ...filterForm, ...saveResponse, isFilter: false });
          setShowFilterModal(false);
        }}
      />
      <DeleteUser
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        onDelete={onDelete}
        deleteLoader={buttonloading}
      />
    </>
  );
};
export default RechargeBeneficiariesTab;
